import { render } from "./freelance-link.vue?vue&type=template&id=85c14ac6"
import script from "./freelance-link.vue?vue&type=script&lang=js"
export * from "./freelance-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__